import axios from "@/plugins/axios";

export default {
  namespaced: true,

  state: {
    availableCarriers: [],
    loadingCarriers: false,
    brokerSettings: {
      broker_id: "",
      carriers: [],
      sync_enabled: false,
    },
    loadingSettings: false,
  },

  mutations: {
    SET_AVAILABLE_CARRIERS(state, carriers) {
      state.availableCarriers = carriers;
    },

    SET_LOADING_CARRIERS(state, loading) {
      state.loadingCarriers = loading;
    },

    SET_BROKER_SETTINGS(state, settings) {
      // Normalize incoming response to ensure consistent shape
      state.brokerSettings = {
        broker_id: settings.broker_id || "",
        carriers: Array.isArray(settings.carriers) ? settings.carriers : [],
        sync_enabled: settings.sync_enabled || false,
      };
    },

    SET_LOADING_SETTINGS(state, loading) {
      state.loadingSettings = loading;
    },
  },

  actions: {
    async fetchAvailableCarriers({ commit }) {
      commit("SET_LOADING_CARRIERS", true);

      try {
        const response = await axios.get("/carriers/synced");

        const carriers = response.data.carriers || [];
        commit("SET_AVAILABLE_CARRIERS", carriers);

        return carriers;
      } catch (error) {
        commit("SET_AVAILABLE_CARRIERS", []);
        throw error;
      } finally {
        commit("SET_LOADING_CARRIERS", false);
      }
    },

    async fetchBrokerSettings({ commit }) {
      commit("SET_LOADING_SETTINGS", true);

      try {
        const response = await axios.get("/broker/carrier_settings");

        const settings = response.data.carrier_settings || {
          broker_id: "",
          carriers: [],
          sync_enabled: false,
        };
        commit("SET_BROKER_SETTINGS", settings);

        return settings;
      } catch (error) {
        commit("SET_BROKER_SETTINGS", {
          broker_id: "",
          carriers: [],
          sync_enabled: false,
        });
        throw error;
      } finally {
        commit("SET_LOADING_SETTINGS", false);
      }
    },

    async saveBrokerSettings({ commit }, carrierIds) {
      const response = await axios.post("/broker/carrier_settings", {
        carrier_ids: carrierIds,
      });

      const settings = response.data.carrier_settings || {
        broker_id: "",
        carriers: [],
        sync_enabled: false,
      };
      commit("SET_BROKER_SETTINGS", settings);

      return {
        success: true,
        message: response.data.message,
        settings,
      };
    },
  },

  getters: {
    isCarrierSyncEnabled: (state) => {
      return state.brokerSettings?.sync_enabled || false;
    },

    selectedCarrierCount: (state) => {
      return state.brokerSettings?.carriers?.length || 0;
    },

    selectedCarrierIds: (state) => {
      return state.brokerSettings?.carriers?.map((c) => c.id) || [];
    },

    selectedCarriers: (state) => {
      return state.brokerSettings?.carriers || [];
    },

    getCarrierById: (state) => (carrierId) => {
      return state.availableCarriers.find((c) => c.entity_id === carrierId);
    },
  },
};
